import React from 'react'
import { Form } from 'react-bootstrap'
import { 
  GoogleLogo,
  GithubLogo 
} from '../../../assets/index'
import { 
  TextInput,
  SButton
} from '../../../components/index'


function SigninForm({
    handleSubmit,
    form,
    handleChange,
    isLoading
}) {

  return (
    <>
        <Form className='form w-100'>
            <div className='text-center mb-11'>
                <h1 className='text-gray-900 fw-bolder mb-3'>Sign In</h1>
                <div className="text-gray-500 fw-semibold fs-6">Your Social Campaigns</div>
            </div>
            <div className='row g-3 mb-9'>
              <div className='col-md-6'>
                <a href='https://www.google.com/'  data-bs-toggle="tooltip" title="Login Google" className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'>
                  <img alt='logo' src={GoogleLogo} className='h-15px me-3'/>
                  Sign in with Google
                </a>
              </div>
              <div className='col-md-6'>
                <a href='https://www.github.com/' data-bs-toggle="tooltip" title="Login Github" className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'>
                  <img alt='logo' src={GithubLogo} className='h-15px me-3'/>
                  Sign in with Apple
                </a>
              </div>

              <div className='separator separator-content my-14'>
                <span className='w-125px text-gray-500 fw-semibold fs-7'>Or with email</span>
              </div>

              <div className='fv-row mb-8'> 
                  <TextInput type={'email'} 
                  name={'email'} 
                  placeholder={'Email'}
                  value={form?.email}
                  clas={'form-control bg-transparent'}
                  onChange={handleChange}
                  ids={'inputEmail'}
                  />
              </div>

              <div className='fv-row mb-8'> 
                  <TextInput type={'password'} 
                  name={'password'} 
                  placeholder={'Password'}
                  value={form?.password}
                  clas={'form-control bg-transparent'}
                  onChange={handleChange}
                  describe={'passwordHelp'}
                  ids={'inputPassword'}
                  />
              </div>

              

              <div className='d-grid mb-10'>
                  <SButton 
                    className={'btn btn-primary'}
                    children={'Sign In'}
                    variant='primary'
                    loading={isLoading}
                    action={handleSubmit}
                    disabled={isLoading}
                  >
                    Sign In
                  </SButton>
              </div>
            </div>
        </Form>
    </>
  )
}

export default SigninForm